import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useHistory } from 'react-router-dom'
import {
  useErrorService,
  useUserService,
  ProsperityAssessmentLoader,
} from '@abroad/components'
import { FreePlanNoSurvey, PageHeader } from '../components'
import API from '../utils/API'
import { surveyType } from '../utils/constants'
import { sortedByDate } from '../utils/date'

const type = 'personal'

const renderHelmet = () => {
  return (
    <Helmet>
      <title>{'True Prosperity Assessment | Abroad'}</title>
      <meta name='title' content={'True Prosperity Assessment | Abroad'}></meta>
      <meta
        property='og:title'
        content={'True Prosperity Assessment | Abroad'}></meta>
      <meta
        property='twitter:title'
        content={'True Prosperity Assessment | Abroad'}></meta>
      <link
        rel='canonical'
        href={`${process.env.REACT_APP_DOMAIN}/prosperity`}></link>
      <meta
        property='og:url'
        content={`${process.env.REACT_APP_DOMAIN}/prosperity`}></meta>
      <meta
        property='twitter:url'
        content={`${process.env.REACT_APP_DOMAIN}/prosperity`}></meta>
    </Helmet>
  )
}

const renderPageHeader = () => (
  <PageHeader title='True Prosperity Assessment' wrapperClasses='mb-32px' />
)

const BeginProsperityAssessment = () => {
  const [isLoading, setIsLoading] = useState(true)
  const Error = useErrorService()
  const { user } = useUserService()
  const history = useHistory()

  useEffect(() => {
    const getProsperitySurveys = async () => {
      try {
        const { data } = await API.survey.getSurveys(
          type,
          surveyType.PROSPERITY,
        ) // (surveyType, filterBy)
        if (data && data?.surveys.length > 0) {
          const sortedSurveys = sortedByDate(data?.surveys, 'createdAt') // (data, key)
          history.push(`/prosperity/${sortedSurveys[0]?._id}`)
          setIsLoading(false)
        } else {
          setIsLoading(false)
        }
      } catch (e) {
        Error.showError(e)
        setIsLoading(false)
      }
    }
    if (user?.prosperityTaken) {
      getProsperitySurveys()
    } else {
      setIsLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {renderHelmet()}
      <main>
        {renderPageHeader()}
        {isLoading ? (
          <ProsperityAssessmentLoader />
        ) : (
          <FreePlanNoSurvey
            type={surveyType.PROSPERITY}
            isRenderOnAwarenessPage={false}
            prosperityPage={true}
          />
        )}
      </main>
    </>
  )
}

export default BeginProsperityAssessment
